<template>
    <div class="incidents-page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div v-if="showSection==='Incidents'">
              <div class="incidents-page-header">
              <!-- Search Bar Row -->
              <b-row class="mb-3">
                <b-col md="4">
                  <div class="incidents-search-wrapper">
                    <b-input-group>
                      <b-input-group-prepend>
                        <span class="input-group-text search-icon">
                          <i class="icofont icofont-search-alt-2"></i>
                        </span>
                      </b-input-group-prepend>
                      <b-form-input
                        class="incidents-search-input"
                        v-model="searchFilter"
                        placeholder="Search"
                        type="search"
                        @input="onSearch"
                      ></b-form-input>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col md="8" class="d-flex justify-content-end align-items-center">
                  <div class="incidents-header-dropdown-wrapper" v-if="!monitor_id">
                    <img src="../assets/icons/incidents-selector.svg" alt="Incidents" class="incidents-selector-icon" />
                    <multiselect
                      class="incidents-header-dropdown"
                  :close-on-select="true"
                  v-model="selected_monitor"
                  tag-placeholder="Select Monitor" 
                  placeholder="Search by Monitor" 
                  label="text" track-by="value" 
                  :show-labels="false"
                  :options="monitor_opt" 
                  :multiple="false"
                  @input="FilterIncedance"
                  :title="selectedMonitorTitle"
                >
                  <template #option="{ option }">
                        <div class="d-flex justify-content-between" :title="option.text">
                          <span class="cus_txt">{{ option.text }}</span>
                          <span v-if="option.badge" class="badge badge-gray ml-2" style="font-size: 12px;">{{ option.badge }}</span>
                      </div>
                  </template>
                  <template #selected="{ option }">
                        <div class="d-flex justify-content-between" :title="option.text">
                          <span class="cus_txt">{{ option.text }}</span>
                          <span v-if="option.badge" class="badge badge-gray ml-2" style="font-size: 12px;">{{ option.badge }}</span>
                      </div>
                  </template>
                </multiselect>
                    <svg class="dropdown-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 10L12 15L17 10" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <div class="incidents-per-page-wrapper ml-3">
                    <img src="../assets/icons/per-page.svg" alt="Per page" class="per-page-icon mr-2" />
                    <span>Per page : </span>
                    <div class="select-wrapper">
                  <b-form-select
                        class="incidents-per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    @change="getIncedent()"
                    :title="`${perPage} per page`"
                    >
                  </b-form-select>
                      <i class="icofont icofont-simple-down select-icon"></i>
                    </div>
                  </div>
                  <add-monitor-button 
                    class="ml-3" 
                    :icon-only="true" 
                    variant="green"
                  />
              </b-col>
            </b-row>
          </div>
          </div>

          <!-- </template> -->
          <div slot="headerAction"></div>
            <div slot="" class="row" v-if="showSection!=='Incidents'">
              <div class="col-md-12" v-if="loading">
                  <div class="loader-box">
                    <div class="loader-30"></div>
                  </div>
              </div> 
              <div v-else class="col-md-12">
                <div class="dashboard-incidents-main-container">
                  <!-- Header inside the container -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="incidents-header">
                        <h2 class="incidents-title custom-font-32">Ongoing Incidents</h2>
                        <div class="incidents-dropdown-wrapper col-md-4" v-if="!monitor_id">
                          <multiselect 
                            class="incidents-dropdown"
                            :close-on-select="true"
                            v-model="selected_monitor"
                            tag-placeholder="Select Monitor" 
                            placeholder="Search by Monitor"  
                            label="text" track-by="value"
                            :show-labels="false" 
                            :options="monitor_opt" 
                            :multiple="false"
                            @input="FilterIncedance"
                            :title="selectedMonitorTitle"
                          >
                            <template #option="{ option }">
                                <div class="d-flex justify-content-between" :title="option.text">
                                    <span class="cust_txt">{{ option.text }}</span>
                                    <span v-if="option.badge" class="badge badge-gray ml-2" style="font-size: 12px;">{{ option.badge }}</span>
                                </div>
                            </template>
                            <template #selected="{ option }">
                                <div class="d-flex justify-content-between" :title="option.text">
                                    <span class="cust_txt">{{ option.text }}</span>
                                    <span v-if="option.badge" class="badge badge-gray ml-2" style="font-size: 12px;">{{ option.badge }}</span>
                                </div>
                            </template>
                          </multiselect>
                          <svg class="dropdown-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 10L12 15L17 10" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Table Container with padding -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="dashboard-table-container table-responsive-custom datatable-vue text-left">
                        <b-table
                          class="dashboard-incidents-table custom-font-20"
                          borderless
                          show-empty
                          stacked="md"
                          :items="incedent_data"
                          :fields="tablefields"
                          @filtered="onFiltered"
                          :per-page="perPage"
                        >
                          <template #cell(status)="data">
                            <div class="dashboard-status-badge" :class="data.item.status ? 'status-resolved' : 'status-ongoing'">
                              <span class="status-text custom-font-16">{{ data.item.status ? 'Resolved' : 'Ongoing' }}</span>
                            </div>
                          </template>
                          <template #cell(mName)="data">
                            <div title="Click here to show more details" style="cursor:pointer;" @click="OpenIncedentDetailModal(data.item)">
                              <span class="incident-name cust_txt custom-font-16" :title="data.item.mName">{{data.item.mName}}</span>
                            </div>
                          </template>
                          <template #cell(duration)="data">
                            <span class="custom-font-16">{{convertMsToHM(data.item.duration)}}</span>
                          </template>
                          <template #cell(createdAt)="data">
                            <span class="custom-font-16">{{changeDateFormate(data.item.createdAt)}}</span>
                          </template>
                          <template #cell(action)="data">
                            <button class="dashboard-action-btn" @click="OpenIncedentDetailModal(data.item)">
                              <img src="../assets/icons/open-modal.svg" alt="Full view" class="action-icon-img" />
                              <span>Full view</span>
                            </button>
                          </template>
                          <template #empty>
                            <div class="no-data-wrapper">
                              <img src="../assets/icons/data-not-found.svg" alt="Data Not Found" class="no-data-image" />
                            </div>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>
                        
                  <!-- Dashboard Pagination Component -->
                  <pagination-component
                    class="pr-0 pl-0 border-0"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :total-items="totalRowsCount"
                    :page-options="pageOptions"
                    @change-page="handlePageChange"
                    @update-per-page="handlePerPageChange"
                  />
                </div>
              </div>
            </div>
            
            <!-- Keep original table for Incidents page -->
            <div v-else>
              <div v-if="loading">
                  <div class="loader-box">
                    <div class="loader-30"></div>
                  </div>
              </div> 
              <div v-else class="incidents-page-table-container">
                <b-table
                  class="incidents-page-table"
                  show-empty
                  stacked="md"
                  :items="incedent_data"
                  :fields="incidentsPageTableFields"
                  @filtered="onFiltered"
                  :per-page="perPage"
                  borderless
                >
                <template #cell(index)="data">
                  <span class="incidents-sr-number custom-font-16">{{ (currentPage - 1) * perPage + data.index + 1 }}</span>
                </template>
                <template #cell(status)="data">
                  <div class="incidents-status-badge" :class="data.item.status ? 'status-resolved' : 'status-ongoing'">
                    <span class="status-dots">
                      <span class="dot dot-1"></span>
                      <span class="dot dot-2"></span>
                      <span class="dot dot-3"></span>
                    </span>
                    <span class="status-text custom-font-16">{{ data.item.status ? 'Resolved' : 'Ongoing' }}</span>
                  </div>
                </template>
                <template #cell(mName)="data">
                  <div title="Click here to show more details" style="cursor:pointer;" @click="OpenIncedentDetailModal(data.item)">
                    <span class="incident-name cus-text custom-font-16" :title="data.item.mName">{{data.item.mName}}</span>
                  </div>
                </template>
                <template #cell(duration)="data">
                  <span class="incidents-duration custom-font-16">{{convertMsToHM(data.item.duration)}}</span>
                </template>
                <template #cell(createdAt)="data">
                  <span class="incidents-date custom-font-16">{{changeDateFormate(data.item.createdAt)}}</span>
                </template>
                <template #cell(mtype)="data">
                  <div class="monitor-type-badge">
                    <span class="type-dot"></span>
                    <span class="type-text custom-font-16">{{ mtypeNames[data.item.mtype] || 'Unknown' }}</span>
                  </div>
                </template>
                <template #cell(action)="data">
                  <button class="incidents-action-btn" @click="OpenIncedentDetailModal(data.item)">
                    <img src="../assets/icons/open-modal.svg" alt="Full view" class="action-icon-img" />
                    <span>Full view</span>
                  </button>
                </template>
                </b-table>
                <!-- Pagination Component -->
                <div class="pagination-wrapper">
                  <pagination-component
                    :current-page="currentPage"
                    :per-page="perPage"
                    :total-items="totalRowsCount"
                    :page-options="pageOptions"
                    @change-page="handlePageChange"
                    @update-per-page="handlePerPageChange"
                  />
              </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Details Modal  -->
      <b-modal id="modal-monitor" size="xl" title="" class="theme-modal custom-modal" v-model="show_details" no-close-on-backdrop hide-footer>
        <template #modal-header>
          <div class="custom-modal-header">
            <h5 class="custom-modal-title">
              <img src="@/assets/icons/incidents-selector.svg" alt="Incident" class="incident-modal-icon" />
              <span class="incident-modal-name" :title="incedent_details.mName">{{ incedent_details.mName }}</span>
              <span class="incident-type-badge">
                <span class="type-dot"></span>
                {{ mtypeNames[incedent_details.mtype] }}
              </span>
            </h5>
            <button class="custom-modal-close" @click="show_details = false" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </template>

        <incedent-details :incedent_details="incedent_details"></incedent-details>

        <!-- No footer -->
      </b-modal>
    </div>
</template>


<script>
import moment from 'moment'
import DashboardController from "../../services/dashboardController";
import HelperFunction from "../../services/helperFunction";
import IncedentDetails from "./IncedentDetails.vue";
import MonitorsController from "../../services/monitorController";
import Multiselect from 'vue-multiselect'
import AddMonitorButton from ".././components/addMonitorButton.vue";
import PaginationComponent from "../components/PaginationComponent.vue";
export default {
  name: "Incedent",
  components:{IncedentDetails, Multiselect, AddMonitorButton, PaginationComponent},
  props:{monitor_id:String,monitor_data:Object,dateRanges:Object,update_filter:Number},
  data() {
    return {
      incedent_details:{},
      incedent_data: [],
      show_details:false,
      filter:null,
      totalRows: 1,
      totalRowsCount: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 50],
      loading:false,
      tablefields: [
      { key: "mName", label: "Name", sortable: true },
      { key: "status", label: "Status", sortable: false },
      { key: "duration", label: "Duration", sortable: false },
      { key: "createdAt", label: "Started At", sortable: false },
      { key: "action", label: "Action", sortable: false },
      ],
      incidentsPageTableFields: [
      { key: "index", label: "Sr.", sortable: false },
      { key: "mName", label: "Name", sortable: true },
      { key: "status", label: "Status", sortable: false },
      { key: "duration", label: "Duration", sortable: false },
      { key: "createdAt", label: "Started At", sortable: false },
      { key: "mtype", label: "Monitor Type", sortable: false },
      { key: "action", label: "Action", sortable: false },
      ],
      all_incedent_data:[],
      monitor_opt: [{ value: null, text: "All Incidents" }],
      selected_monitor: null,
      monitorId:this.monitor_id,
      showSection: '',
      searchFilter: '',
      mtypeNames: {
        1: 'HTTP(s)',
        2: 'Keyword',
        3: 'Ping',
        4: 'Port',
        5: 'Heartbeat',
        6: 'Page Speed',
        7: 'Page Screenshot'
      }
    };
  },
  mounted() {
    this.$root.$data.showAddMoinitor = false;
    this.showSection = this.$route.name || 'Dashboard';
    this.getMonitors();
    if(this.$route.params.mid){
      this.monitorId = this.$route.params.mid
    }
    if(this.showSection === 'Dashboard'){
    this.perPage = 5;
    } else if(!this.monitor_id){
      this.perPage = 10;
    } else {
      this.perPage = 5;
    }
    this.getIncedent();
  },
  watch:{
  async monitor_id(){
      this.currentPage = 1
      this.perPage = 5;
      await this.getIncedent();
    },
  async update_filter(){
      await  this.getIncedent(this.dateRanges)
    }
  },
  computed: {
    selectedMonitorTitle() {
      if (!this.selected_monitor) return 'All Incidents';
      return this.selected_monitor.text || 'All Incidents';
    }
  },
  methods: {
    AddMonitor(){
      this.$root.$data.showAddMoinitor = true;
      this.$router.push("/app/monitor");
    },
    async getMonitors() {
      let response = await MonitorsController.getMonitors();
      if (response.result) {
            response.data.map((t) => {
              let typeBadge = '';
              switch (t.type) {
                  case 1:
                      typeBadge = 'HTTP(s)';
                      break;
                  case 2:
                      typeBadge = 'Keyword';
                      break;
                  case 3:
                      typeBadge = 'Ping';
                      break;
                  case 4:
                      typeBadge = 'Port';
                      break;
                  case 5:
                      typeBadge = 'Heartbeat';
                      break;
                  case 6:
                      typeBadge = 'Page Speed';
                      break;
                  case 7:
                      typeBadge = 'Page Screenshot';
                      break;
                  default:
                      typeBadge = '';
              }

              this.monitor_opt.push({ value: t._id, text: t.name, type: t.type, isDown: t.isDown, badge: typeBadge });
          });
      }
      this.selected_monitor = this.monitor_opt.filter((t)=> t.value == this.monitorId)[0]
    },
    FilterIncedance(){
      if(this.selected_monitor && this.selected_monitor.value !== undefined){
        this.monitorId = this.selected_monitor.value
      }else{
        this.monitorId = null
      }
      this.getIncedent()
    },
    OpenIncedentDetailModal(data){
      this.incedent_details = data
      this.show_details = true
    },
    async getIncedent(dateRange) {
      var mid = this.monitorId?this.monitorId:this.monitor_id
      var payload = '?currentPage='+this.currentPage+'&pageSize='+this.perPage
      if(dateRange){
         payload = '?currentPage='+this.currentPage+'&pageSize='+this.perPage+'&sdate='+dateRange.startDate+'&edate='+dateRange.endDate
       }
      if(mid && mid != null){
         payload = '?mid='+mid+'&currentPage='+this.currentPage+'&pageSize='+this.perPage
         if(dateRange){
         payload = '?mid='+mid+'&currentPage='+this.currentPage+'&pageSize='+this.perPage+'&sdate='+dateRange.startDate+'&edate='+dateRange.endDate
       }
      }
      this.loading = true;
      var response = await DashboardController.getIncedent(payload);
      console.log('Incidents API Response:', response); // Debug log
      if (response.result) {
        this.incedent_data = []
        this.all_incedent_data = []
        this.incedent_data = response.data;
        this.all_incedent_data = this.incedent_data;
        // totalRows should be the count of current page items
        this.totalRows = this.incedent_data.length;
        // totalRowsCount should be the total count across all pages
        this.totalRowsCount = response.totalCount || response.total || response.count || 0;
        console.log('Incidents - Items:', this.incedent_data.length, 'Total Count:', this.totalRowsCount); // Debug log
        
        // If API doesn't return total count and we have a full page, assume there might be more
        if (!this.totalRowsCount && this.incedent_data.length === this.perPage) {
            // Set a high number to enable next button
            this.totalRowsCount = this.currentPage * this.perPage + 1;
        } else if (!this.totalRowsCount) {
            // If less than perPage items, this is likely the last page
            this.totalRowsCount = (this.currentPage - 1) * this.perPage + this.incedent_data.length;
        }
      }
      this.loading = false;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  onCustomFiltered() {
    this.incedent_data = HelperFunction.onCustomFiltered(this.all_incedent_data, this.incedent_data, this.filter)
  },
    changeDateFormate(d){
        return moment(d).format('D/M/YYYY, hh:mm A')
    },
    convertMsToHM(millis) {
      return HelperFunction.convertMsToHM(millis)
    },
    onSearch() {
      // Filter incidents based on search term
      if (this.searchFilter) {
        this.incedent_data = this.all_incedent_data.filter(item => {
          return item.mName.toLowerCase().includes(this.searchFilter.toLowerCase()) ||
                 (this.mtypeNames[item.mtype] || '').toLowerCase().includes(this.searchFilter.toLowerCase())
        });
      } else {
        this.incedent_data = this.all_incedent_data;
      }
      this.totalRows = this.incedent_data.length;
    },
    handlePageChange(direction) {
      if (direction === 'prev' && this.currentPage > 1) {
        this.currentPage--;
      } else if (direction === 'next') {
        this.currentPage++;
      } else if (typeof direction === 'number') {
        this.currentPage = direction;
      }
      this.getIncedent();
    },
    handlePerPageChange(newPerPage) {
      this.perPage = newPerPage;
      this.currentPage = 1;
      this.getIncedent();
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
/* ========== COMMON STYLES ========== */

/* Common button styles */
.btn-common {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 12px 16px;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #344054;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  transition: all 0.2s ease;
  white-space: nowrap;
  height: 47px;
}

.btn-common:hover {
  background: #F9FAFB;
}

/* Common badge styles */
.badge-common {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px 2px 6px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
  white-space: nowrap;
}

/* Common text styles */
.text-poppins {
  font-family: 'Poppins', sans-serif;
}

.text-inter {
  font-family: 'Inter', sans-serif;
}

/* Common table styles */
.table-common {
  margin-bottom: 0;
  width: 100%;
  border: 1px solid #D2E3FB !important;
  border-radius: 20px !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  overflow: hidden;
}

.table-common >>> thead th {
  padding: 15px 20px !important;
  font-family: 'Poppins', sans-serif;
  font-weight: 600 !important;
  color: #161616 !important;
  border-bottom: none !important;
  border-top: none !important;
}

.table-common >>> tbody tr td {
  padding: 15px 20px !important;
  font-family: 'Poppins', sans-serif;
  color: #161616;
  border-bottom: 1px solid #E5E7EB !important;
  vertical-align: middle;
}

.table-common >>> tbody tr:last-child td {
  border-bottom: none !important;
}

/* Common dropdown styles */
.dropdown-wrapper-common {
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 10px;
  min-width: 300px;
}

/* ========== LAYOUT STYLES ========== */

.incidents-page-wrapper {
  width: 100%;
  padding: 0;
}

.d-flex-perPage {
 display: -webkit-box !important;
 justify-content: end !important;
}

/* Incidents Page Specific Styles */
.incidents-page-header {
  margin-bottom: 20px;
  margin-top: 30px;
  width: 100%;
}

/* Search Bar Styles */
.incidents-search-wrapper {
  position: relative;
}

.incidents-search-wrapper .input-group {
  border: 1px solid #D0D5DD;
  border-radius: 12px;
  overflow: hidden;
  background: #FFFFFF;
  padding: 0px;
}

.incidents-search-wrapper .input-group-text {
  background: #FFFFFF;
  border: none;
  padding: 3px 12px;
}

.incidents-search-wrapper .search-icon {
  color: #344054;
  font-size: 18px;
}

.incidents-search-input {
  background: #FFFFFF;
  border: none;
  padding: 3px 12px 3px 8px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #111827;
}

.incidents-search-input:focus {
  box-shadow: none;
  background: transparent;
}

.incidents-search-input::placeholder {
  color: #9CA3AF;
}

/* Monitor Filter Styles - Removed, now using incidents-dropdown */

/* Per Page Styles */
.incidents-per-page-wrapper {
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 12px;
  padding: 0 16px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #344054;
  height: 48px;
}

.incidents-per-page-wrapper .per-page-icon {
  width: 16px;
  height: 18px;
}

.incidents-per-page-wrapper .select-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}

.incidents-per-page-select {
  width: auto;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  padding: 0 20px 0 5px;
  color: #344054;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.incidents-per-page-wrapper .select-icon {
  position: absolute;
  right: 2px;
  pointer-events: none;
  color: #344054;
}

/* Table Container Styles */
.incidents-page-table-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px !important;
  overflow: hidden;
  margin: 0 0 20px 0;
  width: 100%;
}

.incidents-page-table {
  margin-bottom: 0;
  width: 100%;
  border: none !important;
  border-radius: 0 !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  overflow: visible;
}

.incidents-page-table-container >>> .table-responsive {
  overflow-x: auto;
}

.incidents-page-table >>> thead th {
  background: #FFFFFF;
  padding: 30px 20px 15px 20px!important;
  font-family: 'Poppins', sans-serif;
  font-weight: 600 !important;
  font-size: 18px;
  color: #161616 !important;
  border-bottom: 1px solid #E5E7EB !important;
  border-top: none !important;
}

.incidents-page-table >>> tbody tr td {
  padding: 15px 20px !important;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #161616;
  border-bottom: 1px solid #E5E7EB !important;
  vertical-align: middle;
}

.incidents-page-table >>> tbody tr:last-child td {
  border-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.incidents-page-table >>> tbody tr:last-child td:first-child {
  border-bottom-left-radius: 0 !important;
  border-radius: 0 !important;
}

.incidents-page-table >>> tbody tr:last-child td:last-child {
  border-bottom-right-radius: 0 !important;
  border-radius: 0 !important;
}

/* Remove radius from table tbody */
.incidents-page-table >>> tbody {
  border-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

/* Pagination wrapper inside table container */
.incidents-page-table-container .pagination-wrapper {
  background: #FFFFFF;
  border-radius: 0 0 20px 20px;
  padding: 0;
  border-top: none !important;
}

/* Remove any top border from pagination component and its children */
.incidents-page-table-container .pagination-wrapper > *,
.incidents-page-table-container .pagination-wrapper .custom-pagination {
  border-top: none !important;
  margin-top: 0 !important;
}

/* Sr. Number Styles */
.incidents-sr-number {
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  color: #3A3A3A;
}


/* Status Badge Styles */
.incidents-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px 2px 6px;
  border-radius: 16px;
  font-size: 14px !important;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
  white-space: nowrap;
}

.incidents-status-badge.status-ongoing {
  background: rgba(231, 0, 0, 0.1);
  color: #F20707;
}

.incidents-status-badge.status-resolved {
  background: rgba(47, 178, 52, 0.1);
  color: #2FB234;
}

.status-dots {
  position: relative;
  width: 14px;
  height: 14px;
  display: inline-block;
}

.status-dots .dot {
  position: absolute;
  border-radius: 50%;
}

.status-ongoing .dot {
  background: #F20707;
}

.status-resolved .dot {
  background: #2FB234;
}

.dot-1 {
  width: 14px;
  height: 14px;
  top: 0;
  left: 0;
  opacity: 0.2;
}

.dot-2 {
  width: 10px;
  height: 10px;
  top: 2px;
  left: 2px;
  opacity: 0.1;
}

.dot-3 {
  width: 8px;
  height: 8px;
  top: 3px;
  left: 3px;
  opacity: 1;
}

/* Monitor Type Badge Styles */
.monitor-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px 2px 6px;
  background: rgba(41, 51, 64, 0.13);
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
  color: #293340;
  white-space: nowrap;
}

.type-dot {
  width: 8px;
  height: 8px;
  background: #293340;
  border-radius: 50%;
  position: relative;
}

.type-dot::before {
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
  background: #293340;
  border-radius: 50%;
  top: 1px;
  left: 1px;
}

/* Duration and Date Styles */
.incidents-duration,
.incidents-date {
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  color: #3A3A3A;
}

/* Action Button Styles */
.incidents-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #344054;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  transition: all 0.2s ease;
  white-space: nowrap;
}

.incidents-action-btn:hover {
  background: #F9FAFB;
}

.incidents-action-btn .action-icon-img {
  width: 18px;
  height: 18px;
}


/* Dashboard Incidents Styles */
.incidents-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0px 0px 0px;
  position: relative;
  z-index: 10;
}

.incidents-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  color: #3A3A3A;
  margin: 0;
}

.incidents-dropdown-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: #E8EEFD;
  border-radius: 10px;
  padding: 5px 15px;
  min-width: 300px;
}

.incidents-dropdown >>> .multiselect {
  min-height: unset;
  background: transparent;
  border: none;
}

.incidents-dropdown >>> .multiselect__tags {
  background: #E8EEFD !important;
  border: none !important;
  min-height: unset;
  padding: 0;
  max-width: 100% !important;
  overflow: hidden !important;
}

.incidents-dropdown >>> .multiselect__input,
.incidents-dropdown >>> .multiselect__single,
.incidents-dropdown >>> .multiselect__placeholder {
  background: #E8EEFD !important;
  color: #000 !important;
  font-family: 'Inter', sans-serif;
  font-size: 18px !important;
  padding: 0vh 0vw !important;
  margin-top: 10px;
}

.incidents-dropdown >>> .multiselect__select {
  display: none !important;
}

.incidents-dropdown >>> .multiselect__tags:focus-within {
  box-shadow: none !important;
  border: none !important;
}

.incidents-dropdown >>> .multiselect__option--highlight {
  font-size: 16px !important;
  font-family: 'Inter', sans-serif;
}

.incidents-dropdown >>> .multiselect__option {
  font-family: 'Inter', sans-serif;
}

/* Text wrapping for dropdown options */
.incidents-dropdown >>> .multiselect__option .cust_txt,
.incidents-header-dropdown >>> .multiselect__option .cust_txt {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  font-size: 16px;
  text-overflow: ellipsis;
  max-width: calc(100% - 60px); /* Increased from 110px for better text display */
}

/* Text wrapping for selected values */
.incidents-dropdown >>> .multiselect__single .cust_txt,
.incidents-header-dropdown >>> .multiselect__single .cust_txt {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 40px); /* Leave space for badges and arrow */
}

/* Ensure the single value container doesn't overflow */
.incidents-dropdown >>> .multiselect__single,
.incidents-header-dropdown >>> .multiselect__single {
  overflow: hidden !important;
  display: block !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  max-width: calc(100% - 30px) !important;
  padding-right: 20px !important;
}

/* Ensure the flex container in selected template works properly */
.incidents-dropdown >>> .multiselect__single .d-flex,
.incidents-header-dropdown >>> .multiselect__single .d-flex {
  width: 100%;
  min-width: 0; /* Allow flex items to shrink */
}

/* Ensure badges don't get cut off */
.incidents-dropdown >>> .multiselect__single .badge,
.incidents-header-dropdown >>> .multiselect__single .badge {
  flex-shrink: 0;
  margin-left: 8px;
}

/* Ensure badges are visible */
.incidents-header-dropdown >>> .multiselect__option .d-flex {
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.incidents-header-dropdown >>> .multiselect__option .badge {
  flex-shrink: 0;
  margin-left: auto;
}

.dropdown-icon {
  position: absolute;
  right: 10px;
  pointer-events: none;
}

/* Incidents Page Header Dropdown Styles */
.incidents-header-dropdown-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 12px;
  padding: 0 16px;
  height: 48px;
  min-width: 275px;
  max-width: 320px;
  flex: 1;
}

/* Ensure dropdown opens with proper width */
.incidents-header-dropdown-wrapper >>> .multiselect--active {
  z-index: 1000;
}

.incidents-selector-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.incidents-header-dropdown >>> .multiselect {
  min-height: unset;
  background: transparent;
  border: none;
  height: 48px;
  font-size: 14px;
  width: 100% !important;
}

.incidents-header-dropdown >>> .multiselect__tags {
  background: transparent !important;
  border: none !important;
  min-height: unset;
  padding: 0;
  font-family: 'Inter', sans-serif;
  display: flex;
  align-items: center;
  height: 100%;
  max-width: 100% !important;
  overflow: hidden !important;
}

.incidents-header-dropdown >>> .multiselect__input,
.incidents-header-dropdown >>> .multiselect__single,
.incidents-header-dropdown >>> .multiselect__placeholder {
  background: transparent !important;
  color: #344054 !important;
  font-family: 'Inter', sans-serif;
  font-size: 14px !important;
  padding: 0 !important;
  line-height: 41px;
  margin-top: 7px;
}

/* Hide the default multiselect dropdown arrow */
.incidents-header-dropdown >>> .multiselect__select {
  display: none !important;
}

.incidents-header-dropdown >>> .multiselect__tags:focus-within {
  box-shadow: none !important;
  border: none !important;
}

.incidents-header-dropdown >>> .multiselect__option--highlight {
  font-size: 14px !important;
  font-family: 'Inter', sans-serif;
}

.incidents-header-dropdown >>> .multiselect__option {
  font-family: 'Inter', sans-serif;
  font-size: 14px !important;
}

/* Ensure proper vertical centering for the selected value */
.incidents-header-dropdown >>> .multiselect__single {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.incidents-header-dropdown >>> .multiselect__content-wrapper {
  border: 1px solid #D0D5DD;
  border-radius: 0;
  margin-top: 4px;
  min-width: 100%;
  width: max-content !important;
  max-width: 300px;
  left: -16px;
  transform: translateX(0);
  z-index: 1000 !important;
}

.incidents-header-dropdown >>> .multiselect__content {
  width: 100%;
  min-width: 275px;
  border-radius: 0;
}

.incidents-header-dropdown >>> .multiselect__element {
  width: 100%;
}

.incidents-header-dropdown >>> .multiselect__option {
  padding: 10px 12px;
  white-space: nowrap;
  overflow: visible;
  border-radius: 0;
}

/* Remove border radius from first and last options */
.incidents-header-dropdown >>> .multiselect__option:first-child {
  border-radius: 0;
}

.incidents-header-dropdown >>> .multiselect__option:last-child {
  border-radius: 0;
}

.incidents-header-dropdown-wrapper .dropdown-icon {
  color: #344054;
  width: 20px;
  height: 20px;
}

/* Dashboard Table Styles */
.incidents-table-wrapper {
  width: 100%;
}

.dashboard-incidents-main-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  padding: 0 20px 20px 20px;
  position: relative;
}

/* Dashboard pagination styling */
.dashboard-incidents-main-container .custom-pagination {
  margin-top: 0;
  border: none;
  border-radius: 0 0 20px 20px;
  border-top: none;
}



.dashboard-table-container {
  width: 100%;
  overflow: hidden;
  margin-bottom: 0;
}

.dashboard-table-container .dashboard-incidents-table {
  border: 1px solid #D2E3FB !important;
  border-radius: 20px !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  overflow: hidden;
}

.dashboard-table-container .dashboard-incidents-table >>> thead th {
  font-family: 'Poppins', sans-serif;
  padding: 15px 20px !important;
  font-weight: 600 !important;
  color: #161616 !important;
  border-bottom: none !important;
  border-top: none !important;
  white-space: nowrap;
}


.dashboard-table-container .dashboard-incidents-table >>> tbody tr td {
  padding: 15px 20px !important;
  color: #161616;
  border-bottom: 1px solid #E5E7EB !important;
}

.dashboard-table-container .dashboard-incidents-table >>> tbody tr:last-child td {
  border-bottom: none !important;
}

.incident-name {
  color: #0B6CFA;
  cursor: pointer;
  text-decoration: none;
  font-family: 'Poppins', sans-serif;
  display: inline-block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.status-ongoing {
  color: #F20707;
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
}

.status-resolved {
  color: #188007;
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
}

.action-icon {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.action-icon:hover {
  opacity: 0.7;
}

.action-icon >>> svg {
  width: 20px;
  height: 20px;
  color: #6B7280;
}

/* Dashboard Pagination */
.dashboard-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 15px 0;
}

.per-page-wrapper {
  display: flex;
  align-items: center;
}

.per-page-wrapper >>> .form-group {
  margin-bottom: 0;
  background: #F8F9FB;
  border: 1px solid #E5E7EB !important;
}

.per-page-wrapper >>> .col-form-label {
  padding: 5px 10px;
  margin: 0;
  width: auto !important;
  font-size: 16px;
  color: #161616;
}

.per-page-wrapper >>> .custom-select {
  background: #F8F9FB;
  padding: 5px 10px;
}

.page-info-wrapper {
  display: flex;
  align-items: center;
  gap: 15px;
}

.page-info-text {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  color: #161616;
}

.page-navigation {
  display: flex;
  gap: 5px;
}

.page-nav-btn {
  width: 24px;
  height: 24px;
  border: none;
  background: #E5E7EB;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
}

.page-nav-btn:hover:not(:disabled) {
  background: #D1D5DB;
}

.page-nav-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-nav-btn svg {
  width: 12px;
  height: 12px;
  color: #374151;
}

/* Dashboard Status Badge Styles */
.dashboard-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: 'Poppins', sans-serif;
}

.dashboard-status-badge .status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.dashboard-status-badge.status-ongoing .status-dot {
  background: #F20707;
}

.dashboard-status-badge.status-resolved .status-dot {
  background: #2FB234;
}

/* Dashboard Monitor Type Badge Styles */
.dashboard-monitor-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: #E8EEFD;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  color: #344054;
}

.dashboard-monitor-type-badge .type-text {
  font-size: 14px;
  color: #344054;
}

/* Dashboard Incidents Header */
.dashboard-incidents-header {
  padding: 0 0 20px 0;
}

.dashboard-incidents-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 32px;
  color: #3A3A3A;
  margin: 0;
}

/* Dashboard Sr. Number */
.dashboard-sr-number {
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  color: #3A3A3A;
}

/* Dashboard Action Button */
.dashboard-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #344054;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  transition: all 0.2s ease;
  white-space: nowrap;
}

.dashboard-action-btn:hover {
  background: #F9FAFB;
}

.dashboard-action-btn .action-icon-img {
  width: 18px;
  height: 18px;
}

/* Custom font classes for dashboard table */
.custom-font-16,
.custom-font-18,
.custom-font-22 {
  font-family: 'Poppins', sans-serif !important;
}

/* Force green color for add monitor button in this view */
.add-monitor-btn-green.add-monitor-btn-icon {
  background-color: #2FB234 !important;
  border-color: #2FB234 !important;
}

.add-monitor-btn-green.add-monitor-btn-icon:hover {
  background-color: #28A22C !important;
  border-color: #28A22C !important;
}

/* No Data State - Dashboard Only */
.no-data-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 200px;
}

.no-data-image {
  width: 318px;
  height: 283px;
  object-fit: contain;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .dashboard-table-container {
    margin: 0;
    border-radius: 12px !important;
  }
  
  .dashboard-incidents-main-container {
    padding: 0 10px 10px 10px;
  }
  
  /* Adjust table styles for mobile */
  .dashboard-table-container .dashboard-incidents-table {
    border-radius: 12px !important;
  }
  
  .incidents-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    padding: 20px;
  }
  
  .incidents-dropdown-wrapper {
    width: 100%;
  }
  
  .dashboard-incidents-table >>> thead th,
  .dashboard-incidents-table >>> tbody td {
    padding: 10px 15px !important;
    font-size: 14px !important;
  }
  
  /* Hide table responsive scroll on mobile when content fits */
  .table-responsive-custom {
    overflow-x: visible;
  }
  
  /* Use Bootstrap's stacked mode on mobile */
  .dashboard-incidents-table.b-table-stacked-md {
    border: none !important;
  }
  
  .dashboard-pagination {
    flex-direction: column;
    gap: 15px;
    padding: 15px;
  }
  
  .per-page-wrapper,
  .page-info {
    width: 100%;
    justify-content: space-between;
  }

  .no-data-image {
    width: 250px;
    height: 220px;
  }
}

@media (max-width: 576px) {
  .no-data-image {
    width: 200px;
    height: 180px;
  }
}

/* Incident Modal Styles */
.theme-modal >>> .modal-header {
  border-bottom: 1px solid #E5E7EB;
  padding: 24px;
}

.theme-modal >>> .modal-title {
  width: 100%;
  margin: 0;
}

.incident-modal-title {
  display: flex;
  justify-content: center !important;
  align-items: center;
  gap: 12px;
  font-family: 'Poppins', sans-serif;
  width: 100%;
  text-align: center !important;
}

.incident-modal-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.incident-modal-title .incident-name {
  font-size: 24px;
  font-weight: 600;
  color: #161616;
  margin: 0;
}

.incident-modal-title .incident-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: #d3d4d5;
  border-radius: 15px;
  font-size: 16px;
  font-weight: 500;
  color: #344054;
}

.incident-modal-title .incident-type-badge .type-dot {
  width: 6px;
  height: 6px;
  background: #667085;
  border-radius: 50%;
}

/* Custom Modal Styles - Similar to Verify Modal */
.custom-modal .modal-header {
  border-bottom: none;
  padding: 30px 30px 0 30px;
}

.custom-modal-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  position: relative;
}

.custom-modal-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #161616;
  margin: 0;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 12px;
}

.custom-modal-title .incident-modal-icon {
  width: 24px;
  height: 24px;
}

.custom-modal-title .incident-name {
  font-weight: 600;
  color: #161616;
}

.custom-modal-title .incident-modal-name {
  font-weight: 600;
  color: #161616;
  display: inline-block;
  max-width: 450px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  cursor: pointer;
}

.custom-modal-title .incident-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px 2px 6px;
  background: rgba(41, 51, 64, 0.13);
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  color: #293340;
}

.custom-modal-title .incident-type-badge .type-dot {
  width: 8px;
  height: 8px;
  background: #293340;
  border-radius: 50%;
}

.custom-modal-close {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 28px;
  font-weight: 300;
  line-height: 1;
  color: #6B7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.custom-modal-close:hover {
  background: #F3F4F6;
  color: #374151;
}

.custom-modal .modal-body {
  padding: 30px;
  font-family: 'Poppins', sans-serif;
}

/* Fix for multiselect dropdown when opening above */
.dashboard-incidents-main-container {
  position: relative;
}

.incidents-dropdown-wrapper {
  position: static !important; /* Allow dropdown to escape container bounds */
}

/* When dropdown opens above the selector */
.incidents-dropdown-wrapper .multiselect--above .multiselect__content-wrapper,
.incidents-header-dropdown-wrapper .multiselect--above .multiselect__content-wrapper {
  position: fixed !important; /* Use fixed positioning to escape container */
  z-index: 99999 !important;
  bottom: auto !important;
  top: auto !important;
}

/* General fixes for all multiselect dropdowns */
.multiselect__content-wrapper {
  z-index: 99999 !important;
}

.multiselect--active {
  z-index: 9999 !important;
}

/* Ensure the dropdown is visible when opened above */
.multiselect--above .multiselect__content-wrapper {
  margin-bottom: 0 !important;
  border-radius: 5px 5px 0 0 !important;
  border-bottom: 1px solid #e8e8e8 !important;
  border-top: 1px solid #e8e8e8 !important;
}

/* Remove overflow constraints from parent containers for multiselect */
.incidents-page-wrapper {
  overflow: visible !important;
}

/* Table responsive custom styles */
.table-responsive-custom {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Ensure all table text uses Poppins font */
.dashboard-incidents-table {
  font-family: 'Poppins', sans-serif;
}

/* Alternative approach: make the main container position relative with high z-index */
.dashboard-incidents-main-container {
  position: relative;
  z-index: 1;
}

.dashboard-incidents-main-container .multiselect__content-wrapper {
  position: absolute !important;
  z-index: 99999 !important;
}
</style>
